import { useTranslation } from "react-i18next";
import ContentLayout from "@cloudscape-design/components/content-layout";
import Container from "@cloudscape-design/components/container";
import Header from "@cloudscape-design/components/header";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Box from "@cloudscape-design/components/box";
import ColumnLayout from "@cloudscape-design/components/column-layout";

function NextStepsView() {
  const { t } = useTranslation();

  const panels = [
    {
      image: "/Nova-Sonic-Documentation.svg",
      titleKey: "next-steps.documentation.title",
      descriptionKey: "next-steps.documentation.description",
      altKey: "next-steps.documentation.alt_text",
    },
    {
      image: "/Nova-Sonic-Code-Samples.svg",
      titleKey: "next-steps.code-samples.title",
      descriptionKey: "next-steps.code-samples.description",
      altKey: "next-steps.code-samples.alt_text",
    },
    {
      image: "/Nova-Sonic-Workshop.svg",
      titleKey: "next-steps.workshop.title",
      descriptionKey: "next-steps.workshop.description",
      altKey: "next-steps.workshop.alt_text",
    },
  ];

  return (
    <ContentLayout
      header={<Header variant="h1">{t("next-steps.view.title")}</Header>}
    >
      <SpaceBetween size="l">
        <Box variant="p">{t("next-steps.view.description")}</Box>

        <ColumnLayout columns={3}>
          {panels.map((panel) => (
            <div key={panel.titleKey} style={{ height: "100%" }}>
              <Container
                fitHeight
                header={
                  <Header variant="h2">{t(panel.titleKey)}</Header>
                }
              >
                <SpaceBetween size="m">
                  <Box textAlign="center">
                    <img
                      src={panel.image}
                      alt={t(panel.altKey)}
                      style={{
                        width: "100%",
                        maxWidth: "280px",
                        height: "auto",
                      }}
                    />
                  </Box>
                  <Box variant="p">{t(panel.descriptionKey)}</Box>
                </SpaceBetween>
              </Container>
            </div>
          ))}
        </ColumnLayout>
      </SpaceBetween>
    </ContentLayout>
  );
}

export default NextStepsView;
